import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VpnLockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vpn_lock"}/>
}
